// extracted by mini-css-extract-plugin
export var aboveInput = "_l5-0";
export var actionButton = "_l5-5";
export var actionButtonContainer = "_l5-1";
export var actionIcon = "_l5-6";
export var aiInfoContainer = "_l5-2";
export var attachmentWrapper = "_l5-7";
export var bold = "_l5-3";
export var checkIcon = "_l5-8";
export var clickingRecipientBar = "_l5-11";
export var commentThreadSwitch = "_l5-a";
export var draftImage = "_l5-b";
export var draftImageContainer = "_l5-c";
export var draftImages = "_l5-e";
export var editButton = "_l5-g";
export var editor = "_l5-f";
export var editorContainer = "_l5-y";
export var editorErrorTooltipWrapper = "_l5-9";
export var headerDivider = "_l5-h";
export var icon = "_l5-i";
export var info = "_l5-j";
export var internal = "_l5-n";
export var internalDivider = "_l5-k";
export var internalMessage = "_l5-l";
export var messageInputCard = "_l5-m";
export var messageInputForm = "_l5-o";
export var messageInputFormInternal = "_l5-p";
export var options = "_l5-q";
export var publicMessageCustomer = "_l5-s";
export var publicMessageMerchant = "_l5-r";
export var removeImageButton = "_l5-d";
export var replyButtons = "_l5-t";
export var showSignatureButton = "_l5-u";
export var spinner = "_l5-v";
export var verticalButtonDivider = "_l5-4";
export var visibilitySelector = "_l5-w";
export var warning = "_l5-x";
export var wrappingText = "_l5-z";
export var writingInternalNoteTopBorder = "_l5-10";